import React from 'react';
import { jc, jcm } from 'utils';
import { ImagePlaceholder } from '@navi-toolbox/ui-components';
import { PictureCaverProps } from '../types';
import { Styles } from './picture-cover.styles';
import { RemoveButton } from './remove-button';
import { RetryButton } from './retry-button';
import { useTranslation } from 'react-i18next';

export const PictureCover: React.FC<PictureCaverProps> = ({
  src,
  processingIsFailed = false,
  isInProcessing = false,
  className = '',
  onRetryClick,
  onRemoveClick,
  ...htmlProps
}) => {
  const { t } = useTranslation();
  const onRetryCb = React.useCallback(() => {
    onRetryClick?.(src);
  }, [onRetryClick, src]);

  const onRemoveCb = React.useCallback(() => {
    onRemoveClick?.(src);
  }, [onRemoveClick, src]);

  return (
    <div className={jc(Styles.picCover, className)} key={src} {...htmlProps}>
      <div
        className={jcm({
          [Styles.picCoverCntr]: true,
          [Styles.picCoverCntrWithErrorOutline]: processingIsFailed,
        })}
      >
        <ImagePlaceholder
          className={jcm({
            [Styles.picCoverImg]: true,
            [Styles.picCoverImgVeiled]: processingIsFailed || isInProcessing,
          })}
          src={src}
          loading="lazy"
          alt=""
          fallbackAlt={t('ui.image.alt')}
          fallbackWidth={96}
          fallbackHeight={96}
        />
      </div>

      {processingIsFailed && <RetryButton onClick={onRetryCb} />}

      <RemoveButton showInProcessSpinner={isInProcessing} onClick={onRemoveCb} />
    </div>
  );
};
